"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _react = _interopRequireDefault(require("react"));

/* eslint-disable */
var _default = function _default(props) {
  var className = ['uig-button', 'uig-secondary-button'];
  if (props.className) className.push(props.className);
  props = (0, _assign.default)({}, props, {
    className: className.join(' '),
    role: 'button'
  });
  return _react.default.createElement("a", props);
};

exports.default = _default;

//# sourceMappingURL=SecondaryButton.js.map